import React from 'react';
import { Input, Form } from 'antd';

const { TextArea } = Input;

interface Props {
    data: any
    appDetails: any
    error: any
    setIsFormSelected: any;
}

const NewVersion: React.FC<Props> = (props) => {

    return (
        <React.Fragment>
            <div className="row override-content">

                <div className={"col-md-12"}>
                    <Form.Item
                        label={"Version Tag"}
                    >
                        <Input data-test-id="version_tag" defaultValue={props.appDetails && props.appDetails.versionTag} onChange={(e) => props.data('versionTag', e.target.value)} />
                    </Form.Item>
                </div>
                <div className='col-md-12'>
                    <Form.Item
                        label={"Release Notes"}
                    >
                        <TextArea data-test-id="releaseNotes" rows={4} onChange={(e) => props.data('releaseNotes', e.target.value)} />
                    </Form.Item>
                </div>
            </div>
        </React.Fragment>
    )

}


export default NewVersion;
